import i18n from 'helpers/i18n';
import messages from './messages';
import React from 'react';
import { reopenTraining } from 'actions/trainings';
import TrainingActionModal from './TrainingActionModal';

interface ReopenModalProps {
  /** Controls whether the dialog is open. */
  open: boolean;

  /** The ID of the training. */
  trainingId: number;

  /** Callback fired when the component requests to be closed. */
  onClose: () => void;

  /** Callback fired when the training has been reopened. */
  afterSubmit: () => void;
}

const ReopenModal: React.FC<ReopenModalProps> = ({ trainingId, ...props }) => (
  <TrainingActionModal
    {...props}
    title={i18n.ft(messages.reopenModal.header)}
    content={i18n.ft(messages.reopenModal.content)}
    cancelLabel={i18n.ft(messages.reopenModal.cancel)}
    actionLabel={i18n.ft(messages.reopenModal.reopen)}
    action={() => reopenTraining(trainingId)}
    errorField="training"
    unknownErrorMessage={i18n.ft(messages.unknown)}
  />
);

export default ReopenModal;
